import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import Loading from "../Loading";
import { getTiming } from "../../../utils/getTiming";

const CommentsVehicle = ({ vehicle }) => {
  const [loading, setLoading] = useState();
  const [comments, setComments] = useState([]);
  useEffect(() => {
    getData();
  }, [vehicle]);

  async function getData() {
    setLoading(true);
    await httpReauest("GET", "/vehicle/comment/" + vehicle, {}, {}).then(
      ({ data }) => {
        setComments(data.data);
      }
    );
    setLoading(false);
  }
  return (
    <div className="pt-7">
      {loading ? (
        <div className="w-full flex justify-center">
          <Loading />
        </div>
      ) : (
        comments?.map((e) => {
          const now = new Date();
          const newTime = now.getTime() - new Date(e?.createdAt).getTime();
          const hour = newTime / 86400000;
          return (
            <div className="border-dashed border-[#8E9192] py-4 border-t px-1">
              <div className="flex w-full gap-4 items-center">
                <span>
                  <img
                    src="/3da39-no-user-image-icon-27.webp"
                    className="w-[63px] h-[63px] rounded-full"
                    alt="UserImage"
                  />
                </span>
                <span>
                  <h4 className="text-[18px] font-extrabold">{e?.name}</h4>
                  <p className=" text-[14px] mt-1 ">{getTiming(hour)}</p>
                </span>
              </div>
              <p className="text-[14px] leading-6 text-justify mt-4 text-[#393C3D]">
                {e?.content}
              </p>
            </div>
          );
        })
      )}
    </div>
  );
};

export default CommentsVehicle;
